function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import _styled from "styled-components";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { Component } from 'react';
import Downshift from 'downshift';
import differenceWith from 'lodash.differencewith';
import isEqual from 'lodash.isequal';
import PropTypes from 'prop-types';
import { useLocale, pickKeys } from '@adsk/alloy-react-helpers';
import Overlay from '@adsk/alloy-react-overlay';
import { CREATE_TYPE, defaultMenuRenderer, defaultValueRenderer, defaultValueTagRenderer, defaultLabelRenderer, defaultOptionRenderer, defaultCreateOptionRenderer, defaultItemRenderer, defaultFilterOptions, defaultSelectBoxRenderer, defaultGroupHeaderRenderer } from './layout/defaultRenderers';
import SelectBoxControl from './layout/SelectBoxControl';
import SelectBoxMenu from './layout/SelectBoxMenu';
/**
 * SelectBox
 */

var SelectBox = /*#__PURE__*/function (_Component) {
  _inherits(SelectBox, _Component);

  var _super = _createSuper(SelectBox);

  function SelectBox(props) {
    var _this;

    _classCallCheck(this, SelectBox);

    _this = _super.call(this, props);
    _this.stateReducer = _this.stateReducer.bind(_assertThisInitialized(_this));
    _this.getOptionLabel = _this.getOptionLabel.bind(_assertThisInitialized(_this));
    _this.isSameItem = _this.isSameItem.bind(_assertThisInitialized(_this));
    _this.itemToString = _this.itemToString.bind(_assertThisInitialized(_this));
    _this.handleUserAction = _this.handleUserAction.bind(_assertThisInitialized(_this));
    _this.handleInputValueChange = _this.handleInputValueChange.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.renderSelectBox = _this.renderSelectBox.bind(_assertThisInitialized(_this));
    _this.ref = /*#__PURE__*/React.createRef();
    return _this;
  }

  _createClass(SelectBox, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          container = _this$props.container,
          autoFocus = _this$props.autoFocus,
          isOpen = _this$props.isOpen; // for initial rendering the `target` for overlay is undefined

      if (container && (autoFocus || isOpen)) {
        this.forceUpdate();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          defaultValue = _this$props2.defaultValue,
          defaultInputValue = _this$props2.defaultInputValue,
          defaultHighlightedIndex = _this$props2.defaultHighlightedIndex,
          defaultIsOpen = _this$props2.defaultIsOpen,
          value = _this$props2.value,
          isOpen = _this$props2.isOpen,
          options = _this$props2.options,
          searchable = _this$props2.searchable,
          autoFocus = _this$props2.autoFocus,
          inputValue = _this$props2.inputValue,
          onStateChange = _this$props2.onStateChange;
      var initialIsOpen = searchable && autoFocus && isOpen === undefined ? true : defaultIsOpen;
      return /*#__PURE__*/React.createElement(Downshift, {
        itemCount: options.length,
        itemToString: this.itemToString,
        stateReducer: this.stateReducer,
        onUserAction: this.handleUserAction,
        onInputValueChange: this.handleInputValueChange,
        onChange: this.handleChange,
        onStateChange: onStateChange,
        initialSelectedItem: defaultValue,
        initialInputValue: searchable && !initialIsOpen ? defaultInputValue : '',
        initialHighlightedIndex: defaultHighlightedIndex,
        initialIsOpen: initialIsOpen,
        selectedItem: value,
        inputValue: searchable && !initialIsOpen ? inputValue : undefined,
        isOpen: isOpen
      }, this.renderSelectBox);
    }
  }, {
    key: "stateReducer",
    value: function stateReducer(state, _changes) {
      var _this2 = this,
          _changes$selectedItem,
          _state$selectedItem;

      var _this$props3 = this.props,
          multiple = _this$props3.multiple,
          searchable = _this$props3.searchable,
          creatable = _this$props3.creatable,
          clearInputOnSelect = _this$props3.clearInputOnSelect,
          stateReducer = _this$props3.stateReducer;

      var changes = _objectSpread({}, _changes); // stay open on clear


      if (state.isOpen && changes.selectedItem === null) {
        changes.isOpen = true;
      } // don't reset input if value is controlled


      if (multiple && searchable && state.isOpen && changes.type === Downshift.stateChangeTypes.controlledPropUpdatedSelectedItem) {
        changes.inputValue = state.inputValue;
      } else if (multiple && (changes.type === Downshift.stateChangeTypes.clickItem || changes.type === Downshift.stateChangeTypes.keyDownEnter)) {
        changes.isOpen = true;
        var selectedItems = Array.isArray(state.selectedItem) ? state.selectedItem : [];
        var selectedItem = changes.selectedItem;
        var selected = selectedItems.find(function (x) {
          return _this2.isSameItem(x, selectedItem);
        });
        var items = selected ? selectedItems.filter(function (x) {
          return !_this2.isSameItem(x, selectedItem);
        }) : [].concat(_toConsumableArray(selectedItems), [selectedItem]);
        changes.selectedItem = items;

        if (searchable) {
          changes.inputValue = !clearInputOnSelect ? state.inputValue : ''; // if creating, clear the input value

          if (changes.inputValue && creatable && !selected && _changes.selectedItem && _changes.selectedItem[CREATE_TYPE]) {
            changes.inputValue = '';
          }
        }
      }

      if (!searchable) {
        delete changes.inputValue;
      } else if (!state.isOpen && changes.isOpen) {
        changes.inputValue = '';
        changes.highlightedIndex = 0;
      } // auto select the first item when searching


      if (changes.inputValue && !changes.highlightedIndex) {
        changes.highlightedIndex = 0;
      } // do not deselect item when searching


      if (multiple && searchable && state.isOpen && changes.type === Downshift.stateChangeTypes.keyDownEnter && ((_changes$selectedItem = changes.selectedItem) === null || _changes$selectedItem === void 0 ? void 0 : _changes$selectedItem.length) < ((_state$selectedItem = state.selectedItem) === null || _state$selectedItem === void 0 ? void 0 : _state$selectedItem.length)) {
        changes.selectedItem = state.selectedItem;
      }

      if (stateReducer) {
        return stateReducer(state, changes);
      }

      return changes;
    }
  }, {
    key: "getOptionLabel",
    value: function getOptionLabel(item) {
      var _this$props4 = this.props,
          labelGetter = _this$props4.labelGetter,
          labelKey = _this$props4.labelKey;
      return labelGetter ? labelGetter(item) : item[labelKey] || '';
    }
  }, {
    key: "isSameItem",
    value: function isSameItem(a, b) {
      var _this$props5 = this.props,
          isSameOption = _this$props5.isSameOption,
          valueKey = _this$props5.valueKey;
      if (isSameOption) return isSameOption(a, b);
      return a[valueKey] === b[valueKey];
    }
  }, {
    key: "itemToString",
    value: function itemToString(item) {
      var _this$props6 = this.props,
          multiple = _this$props6.multiple,
          showValueAsTags = _this$props6.showValueAsTags;
      if (!item || showValueAsTags) return '';
      if (!multiple) return this.getOptionLabel(item);
      if (item.length === 0) return '';
      if (item.length === 1) return this.getOptionLabel(item[0]);
      return this.props['T'].translate('SELECTED', {
        count: item.length
      });
    }
  }, {
    key: "isSelected",
    value: function isSelected(selectedItem) {
      var multiple = this.props.multiple;
      return multiple ? Array.isArray(selectedItem) && selectedItem.length > 0 : !!selectedItem;
    } // if the option has only key but no label, find the option from options

  }, {
    key: "normalizeValue",
    value: function normalizeValue(selectedItem) {
      var _this3 = this;

      var _this$props7 = this.props,
          multiple = _this$props7.multiple,
          options = _this$props7.options,
          valueKey = _this$props7.valueKey;

      if (multiple) {
        if (!Array.isArray(selectedItem)) return [];
        return selectedItem.map(function (item) {
          if (!_this3.getOptionLabel(item)) {
            return options.find(function (x) {
              return x[valueKey] === item[valueKey];
            }) || item;
          }

          return item;
        });
      } else {
        if (!selectedItem || selectedItem[valueKey] === undefined) return null;

        if (!this.getOptionLabel(selectedItem)) {
          return options.find(function (x) {
            return x[valueKey] === selectedItem[valueKey];
          }) || selectedItem;
        }

        return selectedItem;
      }
    }
  }, {
    key: "handleUserAction",
    value: function handleUserAction(changes) {
      if (changes.isOpen === true) {
        this.props.onOpen();
      }

      if (changes.isOpen === false) {
        this.props.onClose();
      }
    }
  }, {
    key: "handleInputValueChange",
    value: function handleInputValueChange(inputValue, stateAndHelpers) {
      if (stateAndHelpers.type === Downshift.stateChangeTypes.changeInput) {
        this.props.onInputChange(inputValue, stateAndHelpers);
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange(value, stateAndHelpers) {
      var _this$props8 = this.props,
          labelKey = _this$props8.labelKey,
          creatable = _this$props8.creatable,
          onChange = _this$props8.onChange,
          onCreate = _this$props8.onCreate;

      if (creatable) {
        if (Array.isArray(value) && value.length > 0 && value[value.length - 1][CREATE_TYPE]) {
          onCreate(value[value.length - 1][labelKey], stateAndHelpers);
          return;
        }

        if (value && value[CREATE_TYPE]) {
          onCreate(value[labelKey], stateAndHelpers);
          return;
        }
      }

      onChange(value, stateAndHelpers);
    }
  }, {
    key: "renderSelectBox",
    value: function renderSelectBox(stateAndHelpers) {
      var isOpen = stateAndHelpers.isOpen,
          selectedItem = stateAndHelpers.selectedItem;
      var _this$props9 = this.props,
          multiple = _this$props9.multiple,
          options = _this$props9.options,
          keepSelectedOnOptionsChange = _this$props9.keepSelectedOnOptionsChange;
      var isSelected = this.isSelected(selectedItem);
      var selectedValue = this.normalizeValue(selectedItem);
      var resetStaleSelectedValue = !keepSelectedOnOptionsChange && multiple && selectedValue.length > 0;

      if (resetStaleSelectedValue) {
        var difference = differenceWith(selectedValue, options, isEqual);

        if (difference.length > 0) {
          selectedValue = [];
        }
      }

      var _this$props10 = this.props,
          dataTestId = _this$props10['data-testid'],
          invalid = _this$props10.invalid;
      return /*#__PURE__*/React.createElement("div", {
        style: {
          width: '100%'
        }
      }, /*#__PURE__*/React.createElement(_StyledDiv, {
        "data-testid": dataTestId
      }, /*#__PURE__*/React.createElement(SelectBoxControl, _extends({}, this.props, {
        invalid: invalid,
        isSelected: isSelected,
        selectedValue: selectedValue,
        stateAndHelpers: stateAndHelpers,
        innerRef: this.ref
      })), isOpen && /*#__PURE__*/React.createElement(SelectBoxMenu, _extends({
        isSameItem: this.isSameItem
      }, this.props, {
        className: this.props.menuClassName,
        style: this.props.menuStyle,
        isSelected: isSelected,
        selectedValue: selectedValue,
        stateAndHelpers: stateAndHelpers,
        target: this.ref,
        noResultsPlaceholder: this.props.noResultsPlaceholder
      }))));
    }
  }]);

  return SelectBox;
}(Component);

SelectBox.stateChangeTypes = Downshift.stateChangeTypes;
SelectBox.CREATE_TYPE = CREATE_TYPE;
SelectBox.PLACEMENTS = Overlay.PLACEMENTS;
SelectBox.displayName = 'SelectBox';
SelectBox.defaultProps = {
  options: [],
  valueKey: 'value',
  labelKey: 'label',
  subtextKey: 'subtext',
  defaultInputValue: '',
  placement: SelectBox.PLACEMENTS.BOTTOM_START,
  maxMenuHeight: 300,
  keepSelectedOnOptionsChange: true,
  noResultsPlaceholder: true,
  onChange: function onChange() {},
  onCreate: function onCreate() {},
  onInputChange: function onInputChange() {},
  onOpen: function onOpen() {},
  onClose: function onClose() {}
};
SelectBox.propTypes = _objectSpread(_objectSpread({}, pickKeys(Overlay.propTypes, ['container', 'placement'])), {}, {
  /**
   * i18n helper for T.translate('KEY')
   */
  T: PropTypes.object,

  /**
   * The locale to use for translated strings
   */
  locale: PropTypes.string,

  /**
   * Class name for the component
   */
  className: PropTypes.string,

  /**
   * style for the component
   */
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),

  /**
   * Controlled selected value for the component
   */
  options: PropTypes.arrayOf(PropTypes.object),

  /**
   * Default selected value for the component
   */
  defaultValue: PropTypes.oneOfType([PropTypes.object, PropTypes.arrayOf(PropTypes.object)]),

  /**
   * Controlled selected value for the component
   */
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.arrayOf(PropTypes.object)]),

  /**
   * Default input value for the component
   */
  defaultInputValue: PropTypes.string,

  /**
   * Controlled input value for the component
   */
  inputValue: PropTypes.string,

  /**
   * Default highlighted index for the component
   */
  defaultHighlightedIndex: PropTypes.number,

  /**
   * Controlled highlighted index for the component
   */
  highlightedIndex: PropTypes.number,

  /**
   * Whether the menu is open by default
   */
  defaultIsOpen: PropTypes.bool,

  /**
   * Whether the menu is open by controlled
   */
  isOpen: PropTypes.bool,

  /**
   * Whether the component is focused on mount
   */
  autoFocus: PropTypes.bool,

  /**
   * Whether the component is multi selectable
   */
  multiple: PropTypes.bool,

  /**
   * When the component is multi selectable whether
   * the input should keep the selected values
   * when the options change
   */
  keepSelectedOnOptionsChange: PropTypes.bool,

  /**
   * Whether the component is disabled
   */
  disabled: PropTypes.bool,

  /**
   * Whether the component is invalid
   */
  invalid: PropTypes.bool,

  /**
   * Whether the component is clearable
   */
  clearable: PropTypes.bool,

  /**
   * Whether the component is searchable
   */
  searchable: PropTypes.bool,

  /**
   * Whether to show search icon
   */
  showSearchIcon: PropTypes.bool,

  /**
   * Whether the component is creatable
   */
  creatable: PropTypes.bool,

  /**
   * Whether the component is loading options
   */
  isLoading: PropTypes.bool,

  /**
   * Whether to show value as tags
   */
  showValueAsTags: PropTypes.bool,

  /**
   * Whether to clear input on selected when searching
   */
  clearInputOnSelect: PropTypes.bool,

  /**
   * The key of the option value
   */
  valueKey: PropTypes.string,

  /**
   * The key of the option label
   */
  labelKey: PropTypes.string,

  /**
   * `(option) => string`, option label formatter
   */
  labelGetter: PropTypes.func,

  /**
   * The key of the option subtext
   */
  subtextKey: PropTypes.string,

  /**
   * `(option) => string`, option subtext formatter
   */
  subtextGetter: PropTypes.func,

  /**
   * The placeholder for the component
   */
  placeholder: PropTypes.node,

  /**
   * The placeholder for the component when searching
   */
  searchPlaceholder: PropTypes.node,

  /**
   * The content to be shown if the filtered options is empty
   */
  noResultsValue: PropTypes.node,

  /**
   * Class name for the overlay
   */
  overlayClassName: PropTypes.string,

  /**
   * style for the overlay
   */
  overlayStyle: PropTypes.object,

  /**
   * The max height of the menu, the footer is not included
   */
  maxMenuHeight: PropTypes.number,

  /**
   * `(state, changes) => object`, the most powerful function for the component, use it carefully
   */
  stateReducer: PropTypes.func,

  /**
   * `(optionA, optionsB) => boolean`, whether two options are equal
   */
  isSameOption: PropTypes.func,

  /**
   * `(options, inputValue, selectProps) => array`, filter options based on input value
   */
  filterOptions: PropTypes.func,

  /**
   * `(option, index, selectProps) => boolean`, whether the option is disabled
   */
  isOptionDisabled: PropTypes.func,

  /**
   * `(selectProps) => node`, custom footer renderer
   */
  footerRenderer: PropTypes.func,

  /**
   * `({ items, renderItem, selectedValue, highlightedIndex, selectProps }) => node`, custom menu renderer
   */
  menuRenderer: PropTypes.func,

  /**
   * `({ item, index, disabled, selected, itemProps, selectProps }) => node`, custom item renderer
   */
  itemRenderer: PropTypes.func,

  /**
   * `(value, selectProps) => node`, custom value renderer
   */
  valueRenderer: PropTypes.func,

  /**
   * `(item, selectProps) => node`, custom value tag renderer
   */
  valueTagRenderer: PropTypes.func,

  /**
   * `(option, selected, selectProps) => node`, custom option renderer
   */
  optionRenderer: PropTypes.func,

  /**
   * `(option, selected, selectProps) => node`, custom create option renderer
   */
  createOptionRenderer: PropTypes.func,

  /**
   * `(value, stateAndHelpers) => *`, callback when selected value changed
   */
  onChange: PropTypes.func,

  /**
   * `(inputValue, stateAndHelpers) => *`, callback when creating option
   */
  onCreate: PropTypes.func,

  /**
   * `(changes, stateAndHelpers) => *`, callback when internal state changed
   */
  onStateChange: PropTypes.func,

  /**
   * `(inputValue, stateAndHelpers) => *`, callback when searching
   */
  onInputChange: PropTypes.func,

  /**
   * `() => *`, callback when menu opened
   */
  onOpen: PropTypes.func,

  /**
   * `() => *`, callback when menu closed
   */
  onClose: PropTypes.func,

  /**
   * Class name for the menu
   */
  menuClassName: PropTypes.string,

  /**
   * Class name for the menu
   */
  menuStyle: PropTypes.object,

  /**
   * data-testid passed to the container element
   */
  'data-testid': PropTypes.string,

  /**
   * Flag passed to render the SelectboxMenu when no results are returned
   */
  noResultsPlaceholder: PropTypes.bool
});

var WrapperSelectBox = function WrapperSelectBox(props) {
  var _useLocale = useLocale(function (_ref) {
    var locale = _ref.locale;
    return require("./i18n/".concat(locale, ".json"));
  }),
      T = _useLocale.T;

  return /*#__PURE__*/React.createElement(SelectBox, _extends({}, props, {
    T: T
  }));
};

WrapperSelectBox.stateChangeTypes = SelectBox.stateChangeTypes;
WrapperSelectBox.CREATE_TYPE = SelectBox.CREATE_TYPE;
WrapperSelectBox.PLACEMENTS = SelectBox.PLACEMENTS;
WrapperSelectBox.defaultMenuRenderer = defaultMenuRenderer;
WrapperSelectBox.defaultValueRenderer = defaultValueRenderer;
WrapperSelectBox.defaultValueTagRenderer = defaultValueTagRenderer;
WrapperSelectBox.defaultLabelRenderer = defaultLabelRenderer;
WrapperSelectBox.defaultOptionRenderer = defaultOptionRenderer;
WrapperSelectBox.defaultCreateOptionRenderer = defaultCreateOptionRenderer;
WrapperSelectBox.defaultItemRenderer = defaultItemRenderer;
WrapperSelectBox.defaultFilterOptions = defaultFilterOptions;
WrapperSelectBox.defaultSelectBoxRenderer = defaultSelectBoxRenderer;
WrapperSelectBox.defaultGroupHeaderRenderer = defaultGroupHeaderRenderer;
export default WrapperSelectBox;

var _StyledDiv = _styled("div").withConfig({
  displayName: "SelectBox___StyledDiv",
  componentId: "sc-5184gk-0"
})({
  position: 'relative'
});
//# sourceMappingURL=SelectBox.js.map